import Vue from "vue"
import config from '../../config'
import util from './util';

export default {
    getProducts(params = {}) {
        return Vue.http.get(`${config.apiBaseUrl}/zepplin/products`, util.makeRequestConfig(params)).then(res => res.json())
    },

    createProduct(body, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/zepplin/products', body, util.makeRequestConfig(params)).then((response) => response.json())
    },

    updateProduct(id, body, params = {}) {
        return Vue.http.patch(config.apiBaseUrl + '/zepplin/products/' + id, body, util.makeRequestConfig(params)).then((response) => response.json())
    },

    getBrands(params = {}) {
        return Vue.http.get(`${config.apiBaseUrl}/zepplin/brands`, util.makeRequestConfig(params)).then(res => res.json())
    },

    getList(params = {}) {
        return Vue.http.get(config.apiBaseUrl + '/zepplin/categories', util.makeRequestConfig(params)).then((response) => response.json())
    },

    createCategory(body, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/zepplin/categories', body, util.makeRequestConfig(params)).then((response) => response.json())
    },

    updateCategory(id, body, params = {}) {
        return Vue.http.patch(config.apiBaseUrl + '/zepplin/categories/' + id, body, util.makeRequestConfig(params)).then((response) => response.json())
    },

    createBrand(body, params = {}) {
        return Vue.http.post(config.apiBaseUrl + '/zepplin/brands', body, util.makeRequestConfig(params)).then((response) => response.json())
    },

    updateBrand(zepplinBrandId, body, params = {}) {
        return Vue.http.patch(config.apiBaseUrl + '/zepplin/brands/' + zepplinBrandId, body, util.makeRequestConfig(params)).then((response) => response.json())
    },

    getBrandProductsByBrandIds(params = {}) {
        return Vue.http.get(`${config.apiBaseUrl}/zepplin/brand-products`, util.makeRequestConfig(params)).then(res => res.json())
    },

    createBrandProduct(body, params = {}) {
        return Vue.http.post(`${config.apiBaseUrl}/zepplin/brand-products`, body, util.makeRequestConfig(params)).then(res => res.json())
    },

    updateBrandProduct(id, body, params = {}) {
        return Vue.http.patch(`${config.apiBaseUrl}/zepplin/brand-products/${id}`, body, util.makeRequestConfig(params)).then(res => res.json())
    }
}
